import React, { useEffect, useState } from 'react'
import { CustomBlockRenderer } from 'react-native-render-html'
import {
  ActivityIndicator,
  Image,
  Modal,
  Platform,
  ViewStyle,
  TouchableOpacity,
} from 'react-native'
import { ResourceApi } from '@trivie/core/src/services/api-objects'
import { iconClose } from '../../assets/icons'
import { Header } from '../header/header'
import ImageViewer from 'react-native-image-zoom-viewer'
import Lightbox from 'yet-another-react-lightbox'
import 'yet-another-react-lightbox/styles.css'

const ImageRenderer: CustomBlockRenderer = function ImageRenderer(props) {
  const { tnode } = props
  const [src, setSrc] = useState<any>('')
  const [expandImage, setExpandImage] = useState(false)

  useEffect(() => {
    if (!src) {
      ResourceApi.getSourceDetails(Number(tnode.attributes.source_id)).then((res) => {
        setSrc(res.data.filename_or_url)
      })
    }
  }, [tnode])

  return src ? (
    <>
      <TouchableOpacity onPress={() => setExpandImage(true)}>
        <img
          src={src}
          style={{
            objectFit: 'contain',
            maxHeight: 400,
            borderRadius: 12,
            marginTop: 8,
            marginBottom: 8,
            cursor: 'zoom-in',
          }}
        />
      </TouchableOpacity>
      {src && expandImage && (
        <Lightbox
          open={expandImage}
          close={() => setExpandImage(false)}
          slides={[{ src: src || '' }]}
          render={{
            buttonPrev: () => null,
            buttonNext: () => null,
          }}
        />
      )}
    </>
  ) : (
    <ActivityIndicator />
  )
}
const IMAGE_ZOOM_HEADER: ViewStyle = {
  position: 'absolute',
  top: Platform.OS === 'ios' ? 47 : 0,
  zIndex: 9999,
  backgroundColor: 'transparent',
}

export default ImageRenderer
